export enum DropdownSkins {
  DEFAULT,
  FLAT
}
